import * as React from 'react'
import { withRouter } from 'react-router'
import qs from 'qs'
import _ from 'lodash'

import Icon from '../../../../components/ui/Icon/Icon'
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import InputWithSuggestion from '../../../../components/ui/InputWithSuggestion/InputWithSuggestion'
import LeaveModal from '../../../../components/home/LeaveModal/LeaveModal'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import SearchModal from '../../../../components/home/SearchModal/SearchModal'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import {
  StyledBanner,
  BannerContent,
  BannerDescription,
  RewardsCatalogTitle,
  TabContainer,
  TabItem,
  Content,
  FormContainer,
  SelectMallButton,
  InputContainer,
  ViewAll,
  ViewAllLinkButton,
  StyledCatalogList,
  ErrorCard,
  ZingIconComponent,
  StyledLink,
  StyledShopDineCard,
  CardContent,
  LogoContainer,
  Logo,
  Title,
  LogoFiller,
} from './MainView.style'

import * as ExploreApiService from '../../../../services/api/requests/Explore'
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

const tabsEFood = {
  allBrands: 'all-brands',
  mallMerchants: 'mall-merchants',
}

class MainView extends React.Component {
  debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250)

  constructor(props) {
    super(props)

    const { match, doGetAllMalls } = this.props
    const { location } = props.history
    const { activeTab, mallSlug: selectedMallSlug } = match.params

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      searchQuery: initialSearch.q || '',
      searched: [],
      malls: [],
      mallList: [],
      searchMallModalState: false,
      showLeaveModal: false,
      selectedEFood: {},
      suggestedCurrentIndex: -1,
      showSuggestion: false,
      selectedEFoodMallSlug: selectedMallSlug || '',
      selectedCategoryId: 'default',
      selectedCategory: { value: 'default', name: 'All' },
      stores: [],
      storesNearby: [],
      searchModalState: false,
      showMerchantModal: false,
      merchantModalData: [],
      currentTab: activeTab ? activeTab : tabsEFood.allBrands,
      openModal: false,
    }

    doGetAllMalls(this.setState.bind(this))
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const {
      accessToken,
      match,
      location,
      doGetAllBrands,
      doGetEfoodChoices,
    } = this.props
    const { activeTab, mallSlug } = match.params
    if (activeTab === tabsEFood.mallMerchants) {
      if (mallSlug) {
        doGetEfoodChoices({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
      } else this.displaySelectMalls()
    } else doGetAllBrands({ accessToken })(this.setState.bind(this))

    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      accessToken,
      match,
      location,
      doGetAllBrands,
      doGetEfoodChoices,
    } = this.props
    const { currentTab, searchMallModalState, openModal } = this.state
    const { mallSlug, activeTab } = match.params

    if (currentTab !== prevState.currentTab) {
      if (currentTab === tabsEFood.mallMerchants) {
        if (mallSlug) {
          doGetEfoodChoices({ accessToken })({
            mallSlug,
            setStores: this.setState.bind(this),
          })
        } else this.displaySelectMalls()
      }
      if (currentTab === tabsEFood.allBrands) {
        doGetAllBrands({ accessToken })(this.setState.bind(this))
      }
    }

    if (currentTab === tabsEFood.mallMerchants) {
      if (mallSlug !== prevProps.match.params.mallSlug) {
        doGetEfoodChoices({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
      }
    }

    // matching match parameter to state (all brands tab)
    if (activeTab === undefined && currentTab !== tabsEFood.allBrands) {
      this.setState({ currentTab: tabsEFood.allBrands })
    }

    // matching match parameter to state (mall merchants tab)
    if (activeTab !== undefined) {
      if (currentTab !== tabsEFood.mallMerchants)
        this.setState({
          currentTab: tabsEFood.mallMerchants,
        })
      if (mallSlug === undefined && !searchMallModalState)
        this.setState({
          searchMallModalState: true,
        })
      if (!!mallSlug && searchMallModalState && !openModal)
        this.setState({
          searchMallModalState: false,
        })
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  retrieveInitialData = async () => {
    const {
      waitRenderServer,
      renderServer,
      // , selectedMallSlug
    } = this.props

    waitRenderServer(true)

    renderServer()
  }

  onTabChange = newTab => {
    const { push, baseUrl } = this.props
    const { selectedEFoodMallSlug } = this.state

    this.setState({ currentTab: newTab, showSuggestion: false })

    if (newTab === tabsEFood.mallMerchants) {
      if (selectedEFoodMallSlug)
        push(`${baseUrl}/${newTab}/${selectedEFoodMallSlug}`)
      else push(`${baseUrl}/${newTab}`)
    } else push(`${baseUrl}`)
  }

  searchMallModalToggle = e => {
    const {
      selectedEFoodMallSlug,
      // , currentTab
    } = this.state
    const { push } = this.props

    this.setState(
      {
        searchMallModalState: false,
        openModal: false,
        currentTab:
          selectedEFoodMallSlug === ''
            ? tabsEFood.allBrands
            : tabsEFood.mallMerchants,
      },
      () => {
        selectedEFoodMallSlug === '' && push('/zing-eats')
      },
    )
  }

  searchModalToggle = e => {
    this.setState({
      searchModalState: !this.state.searchModalState,
    })
  }

  handleMerchantModal = itemId => {
    ExploreApiService.getStore(itemId).then(response => {
      this.setState({
        showMerchantModal: true,
        merchantModalData: response.data,
      })
    })
  }

  handleMerchantModalClose = e => {
    this.setState({ showMerchantModal: false })
  }

  handleSelectMall = e => {
    this.setState({
      searchMallModalState: true,
      openModal: true,
    })
  }

  onChangeMall = async mallSlugName => {
    const { setSelectedMallSlug, doGetEfoodChoices, accessToken } = this.props

    this.setState({
      searchMallModalState: false,
      selectedEFoodMallSlug: mallSlugName,
    })

    setSelectedMallSlug(mallSlugName)
    doGetEfoodChoices({ accessToken })({
      mallSlugName,
      setStores: this.setState.bind(this),
    })
  }

  sortAlphabetically = (a, b) => {
    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
  }

  handleShowLeaveModal = (brand, isNearbyMall) => {
    const { selectedEFoodMallSlug, currentTab } = this.state
    const selectedMall = this.state.malls.find(
      mall => mall.mallSlugName === selectedEFoodMallSlug,
    )

    let selectedEFood = { ...brand, mall: null, nearby_mall: null }
    if (selectedMall && currentTab === tabsEFood.mallMerchants) {
      if (isNearbyMall)
        selectedEFood = {
          ...selectedEFood,
          nearby_mall: selectedMall.name,
          mall: null,
        }
      else
        selectedEFood = {
          ...selectedEFood,
          mall: selectedMall.name,
          nearby_mall: null,
        }
    }

    this.setState({
      showLeaveModal: true,
      selectedEFood: selectedMall
        ? selectedEFood
        : { ...brand, mall: null, nearby_mall: null },
    })
  }

  handleCloseLeaveModal = onProceed => {
    if (onProceed) {
      const { selectedEFood } = this.state
      setGAEvent('view_efood_link', 'value', selectedEFood.onlineShopUrl)
      setGAEvent(
        'view_efood_link',
        'nearby_mall_name',
        selectedEFood.nearby_mall,
      )
      setGAEvent('view_efood_link', 'mall', selectedEFood.mall)
    }
    this.setState({
      showLeaveModal: false,
    })
    setTimeout(
      () =>
        this.setState({
          selectedEFood: {},
        }),
      10,
    )
  }

  onSearchBrand = e => {
    const { stores } = this.state
    const { value: brand } = e.target || {}
    const searchQuery = brand.toLowerCase()

    const searched = stores.filter(store => {
      const storeName = store.name.toLowerCase()

      return storeName.includes(searchQuery)
    })

    this.setState({
      showSuggestion: true,
      suggestedCurrentIndex: -1,
      searched,
      searchQuery: brand,
    })
  }

  handleSelectSuggestion = (store, index) => {
    this.setState({
      showSuggestion: false,
      suggestedCurrentIndex: index,
      selectedEFood: store,
      searchQuery: store.name,
      searched: [store],
    })
  }

  displaySelectMalls = () => {
    // e.stopPropagation()
    this.setState({
      searchMallModalState: true,
      openModal: true,
    })
  }
  onEnter = (selectedSuggestion, queryState, searched) => {
    this.setState({
      selectedEFood: selectedSuggestion,
      searchQuery: queryState,
      searched: searched,
    })
  }

  handleRedirectToRegister = () => {
    const { push } = this.props
    push('/register')
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      selectedMallSlug,
      setFavoriteMalls,
      match,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      merchantModalStatus,
      ...theProps
    } = this.props

    const {
      searchQuery: searchQueryState,
      stores,
      storesNearby,
      searched,
      showLeaveModal,
      selectedEFood,
      // selectedEFoodMallSlug,
      showMerchantModal,
      merchantModalData,
      currentTab,
      // suggestedCurrentIndex,
      showSuggestion,
    } = this.state

    const { mallSlug, activeTab } = match ? match.params : {}
    const selectedMall = this.state.malls.find(
      mall => mall.mallSlugName === mallSlug,
    )

    const Banner = () => (
      <StyledBanner
        image={
          currentTab !== tabsEFood.allBrands &&
          selectedMall &&
          selectedMall.photos &&
          selectedMall.photos[0]
        }
      >
        <BannerContent>
          <BannerDescription>
            <RewardsCatalogTitle>ZingEats</RewardsCatalogTitle>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )
    return (
      <CatalogLayout
        banner={Banner}
        isEfoodChoices={true}
        match={match}
        selectedMall={selectedMall}
        accessToken={accessToken}
        tabs={
          <TabContainer>
            <TabItem
              selected={currentTab === tabsEFood.allBrands}
              onClick={() => this.onTabChange(tabsEFood.allBrands)}
            >
              All Brands
            </TabItem>
            <TabItem
              selected={currentTab === tabsEFood.mallMerchants}
              onClick={() => this.onTabChange(tabsEFood.mallMerchants)}
            >
              Mall Merchants
            </TabItem>
          </TabContainer>
        }
        {...theProps}
      >
        <Content>
          {currentTab === tabsEFood.mallMerchants && (
            <>
              <FormContainer>
                <SelectMallButton
                  onClick={e => {
                    this.handleSelectMall(e)
                  }}
                >
                  <span>
                    {(selectedMall && selectedMall.name) || 'Select Mall'}
                  </span>
                  <Icon name="caret" />
                </SelectMallButton>
                <InputContainer onClick={this.searchModalToggle}>
                  Search Merchant
                  <Icon name="search" />
                </InputContainer>
              </FormContainer>
              {stores && stores.length > 0 && selectedMall && (
                <>
                  <ViewAll>
                    <h3>Featured Merchants</h3>
                    <ViewAllLinkButton
                      to={`/zing-eats/${selectedMall.mallSlugName}/view-all/featured`}
                    >
                      View all
                    </ViewAllLinkButton>
                  </ViewAll>
                  <StyledCatalogList
                    dataSource={stores.slice(0, 6)}
                    loadingComponent={() => (
                      <ErrorCard>
                        <ZingIconComponent />
                      </ErrorCard>
                    )}
                    renderItem={(merchant, index) => (
                      <StyledLink
                        onClick={() => {
                          this.handleShowLeaveModal(merchant)
                        }}
                      >
                        <StyledShopDineCard
                          cardImageUrl={merchant.backgroundUrl}
                        >
                          <CardContent>
                            <LogoContainer
                              cardImageUrl={merchant.backgroundUrl}
                            >
                              {merchant.logoUrl ? (
                                <Logo src={merchant.logoUrl} />
                              ) : (
                                <LogoFiller>&nbsp;</LogoFiller>
                              )}
                            </LogoContainer>
                            <Title>{merchant.name}</Title>
                          </CardContent>
                        </StyledShopDineCard>
                      </StyledLink>
                    )}
                  />
                </>
              )}
              {storesNearby && storesNearby.length > 0 && selectedMall && (
                <>
                  <ViewAll>
                    <h3>Near {selectedMall.name || 'Mall'}</h3>
                    <ViewAllLinkButton
                      to={`/zing-eats/${selectedMall.mallSlugName}/view-all/near-mall`}
                    >
                      View all
                    </ViewAllLinkButton>
                  </ViewAll>
                  <StyledCatalogList
                    dataSource={storesNearby.slice(0, 6)}
                    loadingComponent={() => (
                      <ErrorCard>
                        <ZingIconComponent />
                      </ErrorCard>
                    )}
                    renderItem={(merchant, index) => (
                      <StyledLink
                        onClick={() => {
                          this.handleShowLeaveModal(merchant, true)
                          // setGAEvent(
                          //   'item_clicks',
                          //   'view_efood_choice',
                          //   merchant.name,
                          // )
                        }}
                      >
                        <StyledShopDineCard
                          cardImageUrl={merchant.backgroundUrl}
                        >
                          <CardContent>
                            <LogoContainer
                              cardImageUrl={merchant.backgroundUrl}
                            >
                              {merchant.logoUrl ? (
                                <Logo src={merchant.logoUrl} />
                              ) : (
                                <LogoFiller>&nbsp;</LogoFiller>
                              )}
                            </LogoContainer>
                            <Title>{merchant.name}</Title>
                          </CardContent>
                        </StyledShopDineCard>
                      </StyledLink>
                    )}
                  />
                </>
              )}
            </>
          )}
          {currentTab === tabsEFood.allBrands && (
            <>
              <FormContainer>
                <InputWithSuggestion
                  variant="search"
                  whiteOut
                  iconColor={'#4a4a4a'}
                  placeholder="Search Brand"
                  onChange={this.onSearchBrand}
                  value={searchQueryState}
                  onEnter={this.onEnter}
                  showSuggestion={showSuggestion}
                  handleSelectSuggestion={this.handleSelectSuggestion}
                  dataSource={searched}
                  dark
                />
              </FormContainer>
              {stores && stores.length > 0 && (
                <StyledCatalogList
                  dataSource={searchQueryState.length ? searched : stores}
                  loadingComponent={() => (
                    <ErrorCard>
                      <ZingIconComponent />
                    </ErrorCard>
                  )}
                  renderItem={(merchant, index) => (
                    <StyledLink
                      onClick={() => {
                        this.handleShowLeaveModal(merchant)
                      }}
                    >
                      <StyledShopDineCard cardImageUrl={merchant.backgroundUrl}>
                        <CardContent>
                          <LogoContainer cardImageUrl={merchant.backgroundUrl}>
                            {merchant.logoUrl ? (
                              <Logo src={merchant.logoUrl} />
                            ) : (
                              <LogoFiller>&nbsp;</LogoFiller>
                            )}
                          </LogoContainer>
                          <Title>{merchant.name}</Title>
                        </CardContent>
                      </StyledShopDineCard>
                    </StyledLink>
                  )}
                />
              )}
            </>
          )}
        </Content>

        <SearchMallModal
          modalState={
            this.state.searchMallModalState &&
            activeTab === tabsEFood.mallMerchants
          }
          onClose={this.searchMallModalToggle}
          malls={this.state.malls}
          push={push}
          match={match}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          baseUrl={`${baseUrl}/${currentTab}`}
          currentMall={selectedMall && selectedMall.name}
          onChangeMall={this.onChangeMall}
          selectedMall={selectedMall}
          deviceLocation={deviceLocation}
          displayClose={selectedMall && selectedMall.name !== ''}
          favoriteMalls={favoriteMalls}
          setSelectedMallSlug={setSelectedMallSlug}
          efood
        />

        {this.state.searchModalState && (
          <SearchModal
            altTitle={'ZingEats'}
            onCloseSelectMall={this.handleCloseSelectMall}
            onClose={this.searchModalToggle}
            onSelectMerchant={this.handleShowLeaveModal}
            initialMall={selectedMall}
            malls={this.state.malls}
            mallList={this.state.mallList}
            push={push}
            match={match}
            contentType={2}
            accessToken={accessToken}
            favoriteMalls={favoriteMalls}
            deviceLocation={deviceLocation}
            setFavoriteMalls={setFavoriteMalls}
            isEfoodChoices={true}
          />
        )}

        <StoreModal
          malls={this.state.malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleMerchantModalClose}
        />

        <LeaveModal
          show={showLeaveModal}
          onClose={() => {
            this.handleCloseLeaveModal()
          }}
          onAltClose={!accessToken && this.handleRedirectToRegister}
          altCloseTitle={!accessToken && 'Join Now'}
          isError={selectedEFood && !selectedEFood.onlineShopUrl}
          errorMessage={'No shop link found'}
          to={
            selectedEFood.onlineShopUrl
              ? /https:\/\/[a-zA-Z0-9]+/.test(selectedEFood.onlineShopUrl)
                ? selectedEFood.onlineShopUrl
                : `https://${selectedEFood.onlineShopUrl}`
              : ''
          }
          onProceed={() => {
            this.handleCloseLeaveModal(true)
          }}
          isLoggedIn={accessToken}
          promoCode={selectedEFood && selectedEFood.promoCode}
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
